// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2quEj","label":"styles_label__3-sfD"};